import { useCallback, useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

import api from '../../Api/apiAxios';
import styles from './Manutencao.module.css';

const INTERVALO_VERIFICACAO_MS = 15000;

export function Manutencao() {
  const [verificando, setVerificando] = useState(false);

  const verificarConexao = useCallback(() => {
    setVerificando(true);
    api.get('').finally(() => setVerificando(false));
  }, []);

  useEffect(() => {
    const intervalo = setInterval(verificarConexao, INTERVALO_VERIFICACAO_MS);
    return () => clearInterval(intervalo);
  }, [verificarConexao]);

  return (
    <Box className={styles.wrapper}>
      <Box className={styles.card}>
        <Box className={styles.iconBadge}>
          <span className={styles.pulseRing} />
          <span className={styles.pulseRing} style={{ animationDelay: '1s' }} />
          <ConstructionRoundedIcon className={styles.icon} />
        </Box>

        <Typography component="h1" className={styles.titulo}>
          Portal em manutenção
        </Typography>

        <Typography className={styles.subtitulo}>
          Estamos realizando uma manutenção para melhorar sua experiência.
          O portal estará disponível novamente em breve.
        </Typography>

        <Button
          onClick={verificarConexao}
          disabled={verificando}
          disableElevation
          className={styles.botao}
          startIcon={
            <RefreshRoundedIcon className={verificando ? styles.spin : undefined} />
          }
        >
          {verificando ? 'Verificando...' : 'Tentar novamente'}
        </Button>

        <Box className={styles.status}>
          <span className={styles.statusDot} />
          <Typography className={styles.statusTexto}>
            Verificando a conexão automaticamente
          </Typography>
        </Box>
      </Box>

      <Typography className={styles.rodape}>
        BMA Sistemas
      </Typography>
    </Box>
  );
}
